import { Link } from "react-router-dom";

import "./Breadcrumb.css";

/** Figma: Nav/Breadcrumb, gap 4, trailing crumb in slate-700 medium. */
export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav className="crumbs" aria-label="Breadcrumb">
      {items.map((c, i) => (
        <span key={`${c.label}-${i}`} className="crumbs__item">
          {c.to && i < items.length - 1 ? (
            <Link to={c.to} className="crumbs__link">
              {c.label}
            </Link>
          ) : (
            <span className={i === items.length - 1 ? "crumbs__current" : "crumbs__link"}>
              {c.label}
            </span>
          )}
          {i < items.length - 1 && <span className="crumbs__sep">/</span>}
        </span>
      ))}
    </nav>
  );
}
